import { soyshareApi } from '../../../../../services/api'

const api = soyshareApi.injectEndpoints({
  endpoints: (build) => ({
    getActionType: build.query({
      query: ({ actionTypeId }) => ({ url: `/action-types/${actionTypeId}` }),
      providesTags: ['action-type']
    }),

    updateActionType: build.mutation({
      query: ({ actionTypeId, payload }) => ({
        url: `/action-types/${actionTypeId}`,
        method: 'PUT',
        body: payload
      }),
      invalidatesTags: ['action-type']
    }),

    storeActionType: build.mutation({
      query: ({ payload }) => ({
        url: '/action-types',
        method: 'POST',
        body: payload
      })
    })
  })
})

export const { useGetActionTypeQuery, useUpdateActionTypeMutation, useStoreActionTypeMutation } = api
